import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import IconButton from '@mui/material/IconButton';

const AddOptionsAssgin = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
    const [disabled, setdisabled] = useState(false);
    const [guestBadgeImage, setGuestBadgeImage] = useState("");
    const [eventOptionsSetup, setEventOptionsSetup] = useState({
        cate_to_abst: "",
        guest_email_action: "",
        guest_email_action: "",
        workshop_setup_status: "",
        guestBadgeImage:"",
        error_list: [],
    });


    React.useEffect(() => {
        axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getOptionsData = res.data.getOptions;
                setEventOptionsSetup(getOptionsData);
                // Parse the JSON string for abstractSponserLogos


            }
        });
    }, [eventid]);


    const handleInput = (e) => {
        const { name, value } = e.target;
        setEventOptionsSetup(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleGuest = (e) => {
        const { name, value } = e.target;

        setEventOptionsSetup((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const handleWokshop = (e) => {
        const { name, value } = e.target;

        setEventOptionsSetup((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    

    const handleBannerChange = (e) => {
        setGuestBadgeImage(e.target.files[0]);
    };

    console.log(eventOptionsSetup)

    const optionSubmit = (e) => {
        e.preventDefault();
        // const data = {
        //     eventid,

        //     change_status: eventOptionsSetup?.cate_to_abst && eventOptionsSetup.cate_to_abst !== "" 
        //        ? eventOptionsSetup.cate_to_abst 
        //        : 0,
        //        guest_email_status: eventOptionsSetup?.guest_email_action && eventOptionsSetup.guest_email_action !== "" 
        //        ? eventOptionsSetup.guest_email_action 
        //        : 1,

        //     // change_status: eventOptionsSetup?.cate_to_abst ? eventOptionsSetup?.cate_to_abst === "" : eventOptionsSetup.cate_to_abst : 0,
        //     //guest_email_status: eventOptionsSetup?.guest_email_action === "" ? eventOptionsSetup.guest_email_action : 1

        //     // change_status: eventOptionsSetup.cate_to_abst === "" ? eventOptionsSetup.cate_to_abst : 0,
        //     // guest_email_status: eventOptionsSetup.guest_email_action === "" ? eventOptionsSetup.guest_email_action : 1
        //     // change_status: eventOptionsSetup.cate_to_abst ,
        //     // guest_email_status: eventOptionsSetup.guest_email_action,


        // };
        const data = {
            eventid,
            change_status: eventOptionsSetup?.cate_to_abst && eventOptionsSetup.cate_to_abst !== ""
                ? eventOptionsSetup.cate_to_abst
                : 0,
            guest_email_status: eventOptionsSetup?.guest_email_action !== undefined && eventOptionsSetup.guest_email_action !== null
                ? eventOptionsSetup.guest_email_action
                : 1,
            workshop_setup_status: eventOptionsSetup?.workshop_setup_status !== undefined && eventOptionsSetup.workshop_setup_status !== null
                ? eventOptionsSetup.workshop_setup_status
                : 1,
                
            guestBadgeImage,

        };


        setdisabled(true);

        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.post(`/api/add-option-setup`, data, config).then(res => {
                if (res.data.status === 200) {
                    swal('Success', res.data.message, 'success');
                    history.push('/admin/options/index-assign')

                }
                else {
                    setEventOptionsSetup({ ...eventOptionsSetup, error_list: res.data.validate_error })
                }
            });
        });


    }
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        guestBadgeImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        backgroundColor: backGroundButtonByEvent,
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        BAck
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Options Settings
                        </Typography>
                        <Box component="form" onSubmit={optionSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>

                                <Grid item xs={6} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">Add Reviewer By Category/Abstract</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="Add Reviewer By Category/Abstract "
                                            name="cate_to_abst" // Ensure this matches the property name in your state
                                            value={eventOptionsSetup?.cate_to_abst || "0"}
                                            onChange={handleInput}>
                                            <MenuItem value={1}>Abstract</MenuItem>
                                            <MenuItem value={0}>Category</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="guest-email-action-label">Guest Auto Verify / Manual Verify</InputLabel>
                                        <Select
                                            labelId="guest-email-action-label"
                                            id="guest-email-action-select"
                                            label="Guest Auto Verify / Manual Verify"
                                            name="guest_email_action"
                                            value={eventOptionsSetup?.guest_email_action ?? "1"} // Use nullish coalescing instead of "||"
                                            onChange={handleGuest}
                                        >
                                            <MenuItem value={1}>Auto Verify</MenuItem>
                                            <MenuItem value={0}>Manual Verify</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="guest-email-action-label">Workshop Select By Date / Select By Day Date Starting Timey</InputLabel>
                                        <Select
                                            labelId="guest-email-action-label"
                                            id="guest-email-action-select"
                                            label="Workshop Select By Date / Select By Day Date Starting Time"
                                            name="workshop_setup_status"
                                            value={eventOptionsSetup?.workshop_setup_status || "0"} // Use nullish coalescing instead of "||"
                                            onChange={handleWokshop}
                                        >
                                            <MenuItem value={1}>Select By Date</MenuItem>
                                            <MenuItem value={0}>Select By Day Date Starting Time </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <label htmlFor="banner-upload">
                                        <TextField id="icon-button-file" type="file" onChange={(e) => setGuestBadgeImage(e.target.files[0])} name="[licenseFile]" />
                                        <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => document.getElementById('banner-upload').click()}>
                                            <PhotoCamera />
                                        </IconButton>
                                        Upload Exhibition Guest Badge
                                    </label>
                                    <FormHelperText>
                                        {eventOptionsSetup.error_list?.guest_badge
                                            ? `${eventOptionsSetup.error_list?.guest_badge} width=1920, height=1160`
                                            : ""}
                                    </FormHelperText>

                                    {/* {abstractBannerImage && (
                                        <div>
                                            <h4>Selected Banner:</h4>
                                            <p>{abstractBannerImage.name}</p>
                                        </div>
                                    )} */}

                                    <div>  {

                                        eventOptionsSetup?.guest_badge === "no_image.jpg" ? "" :

                                            <img src={eventOptionsSetup?.guest_badge} width="300" height="400" />

                                    }
                                    </div>
                                </Grid>


                            </Grid>
                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                                    Submit
                                </Button>

                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div>
    );
}


export default AddOptionsAssgin;
